import { Region } from 'types/model';

export const additionalCities = (moscow: Region) => {
  const moscowRegion = 'moscow-region';
  return [
    {
      regionId: moscow.regionId,
      regionName: 'Химки (Москва)',
      regionCode: moscowRegion,
      currentPageLink: moscow.currentPageLink,
    },
    {
      regionId: moscow.regionId,
      regionName: 'Мытищи (Москва)',
      regionCode: moscowRegion,
      currentPageLink: moscow.currentPageLink,
    },
    {
      regionId: moscow.regionId,
      regionName: 'Шолохово (Москва)',
      regionCode: moscowRegion,
      currentPageLink: moscow.currentPageLink,
    },
    {
      regionId: moscow.regionId,
      regionName: 'Пушкино (Москва)',
      regionCode: moscowRegion,
      currentPageLink: moscow.currentPageLink,
    },
    {
      regionId: moscow.regionId,
      regionName: 'Троицк (Москва)',
      regionCode: moscowRegion,
      currentPageLink: moscow.currentPageLink,
    },
    {
      regionId: moscow.regionId,
      regionName: 'Люберцы (Москва)',
      regionCode: moscowRegion,
      currentPageLink: moscow.currentPageLink,
    },
    {
      regionId: moscow.regionId,
      regionName: 'Зеленоград (Москва)',
      regionCode: moscowRegion,
      currentPageLink: moscow.currentPageLink,
    },
    {
      regionId: moscow.regionId,
      regionName: 'Климовск (Москва)',
      regionCode: moscowRegion,
      currentPageLink: moscow.currentPageLink,
    },
    {
      regionId: moscow.regionId,
      regionName: 'Красногорск (Москва)',
      regionCode: moscowRegion,
      currentPageLink: moscow.currentPageLink,
    },
    {
      regionId: moscow.regionId,
      regionName: 'Домодедово (Москва)',
      regionCode: moscowRegion,
      currentPageLink: moscow.currentPageLink,
    },
    {
      regionId: moscow.regionId,
      regionName: 'Юдино (Москва)',
      regionCode: moscowRegion,
      currentPageLink: moscow.currentPageLink,
    },
  ];
};
